var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleWithArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 600,
    viewBox: "0,0,1200,600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-450 -1200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 1469.5C512 1173.2 752.199 933 1048.5 933 1344.8 933 1585 1173.2 1585 1469.5 1585 1765.8 1344.8 2006 1048.5 2006 752.199 2006 512 1765.8 512 1469.5Z",
    stroke: "#BFBFBF",
    strokeWidth: 10.3125,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 24.4799 0 24.4799 0 0 48.0001 35.9999 0 71.9998 0 47.5199 0 47.5199Z",
    fill: "#D9D9D9",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 1075 1971)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 25.2287 0 25.2287 0 0 49.4682 37.101 0 74.202 0 48.9733 0 48.9733Z",
    fill: "#D9D9D9",
    fillRule: "evenodd",
    transform: "matrix(-0.422618 -0.906308 -0.906308 0.422618 617.159 1720.34)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 24.3332 0 24.3332 0 0 49.7364 35.7841 0 71.5682 0 47.235 0 47.235Z",
    fill: "#D9D9D9",
    fillRule: "evenodd",
    transform: "matrix(-0.422618 0.906308 0.906308 0.422618 1505.59 1672.07)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 24.9436 0 24.9436 0 0 48.9093 36.6818 0 73.3636 0 48.42 0 48.42Z",
    fill: "#D9D9D9",
    fillRule: "evenodd",
    transform: "matrix(0.712475 -0.701697 -0.701697 -0.712475 705.45 1106.23)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 36.8749 0 36.8749 0 0 47.1426 36.8749 0 73.7498 0 36.8749 0 36.8749Z",
    fill: "#D9D9D9",
    fillRule: "evenodd",
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1374.68 1086.75)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleWithArrows);
export default __webpack_public_path__ + "static/media/circleWithArrows.1ca639208dc29c0453a0f1db8fdbad5f.svg";
export { ForwardRef as ReactComponent };